import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    /** The static age gate built by the inline script in index.html. */
    __bhgGate?: { show: () => void; hide: () => void; accepted: () => boolean };
  }
}

/**
 * The age gate is static HTML built by an inline script in index.html, outside #root, so it
 * paints with the first frame instead of waiting for the bundle (see the comment there). That
 * script runs once per page load. This component covers the remaining case: a client-side
 * navigation from an exempt page (/terms, /privacy, /lp, /welcome, /embed) to a gated one. It
 * renders nothing and asks the same gate to re-check on every route change.
 */
export default function DisclaimerGate() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.__bhgGate?.show();
  }, [pathname]);

  return null;
}
